import { render, staticRenderFns } from "./Calculadora-producto.vue?vue&type=template&id=5a077ec4&scoped=true&lang=html&"
import script from "./Calculadora-producto.vue?vue&type=script&lang=js&"
export * from "./Calculadora-producto.vue?vue&type=script&lang=js&"
import style0 from "./Calculadora-producto.vue?vue&type=style&index=0&id=5a077ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a077ec4",
  null
  
)

export default component.exports